function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

var _ref = /*#__PURE__*/React.createElement("style", null, ".burglary-notification_svg__st0{fill-rule:evenodd;clip-rule:evenodd;fill:#dbf5f5}");

var _ref2 = /*#__PURE__*/React.createElement("g", {
  id: "burglary-notification_svg__Page-1"
}, /*#__PURE__*/React.createElement("g", {
  id: "burglary-notification_svg__Artboard",
  transform: "translate(-55 -94)"
}, /*#__PURE__*/React.createElement("g", {
  id: "burglary-notification_svg__notificatie-illustratie",
  transform: "translate(52 85)"
}, /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval",
  className: "burglary-notification_svg__st0",
  d: "M11.34 29.73c0 1.77 1.43 3.2 3.2 3.2 1.77 0 3.2-1.43 3.2-3.2"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval-Copy-17",
  d: "M17.86 29.65a3.35 3.35 0 01-6.7.06v-.06h.49a2.86 2.86 0 002.86 2.86c1.57 0 2.84-1.26 2.86-2.82v-.05h.49z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Combined-Shape",
  d: "M14.41 11.66h-.02c-.27 0-.73.06-1.23.2-.75.21-1.49.56-2.16 1.08-.85.65-1.55 1.52-2.06 2.65-.59 1.29-.9 2.88-.91 4.79v.08c.19 3.27-.34 5.41-1.57 6.45l-.19.16.16.19c1.67 1.94 4.33 2.9 7.95 2.9h.11c3.57-.02 6.19-.98 7.85-2.9l.16-.19-.19-.16c-1.21-1.03-1.75-3.14-1.57-6.36l.01-.1v-.01c0-1.92-.31-3.52-.89-4.82-.5-1.12-1.19-2-2.03-2.65a6.46 6.46 0 00-2.15-1.1c-.51-.14-.98-.21-1.27-.21zm-.02.49h.01c.25 0 .67.07 1.13.2.69.2 1.37.53 1.99 1.01.78.61 1.42 1.42 1.89 2.47l.02.04c.53 1.2.82 2.68.83 4.46v.11l-.01.09c-.17 3.18.33 5.37 1.54 6.57l.02.01-.03.04c-1.56 1.66-3.99 2.5-7.29 2.52H14.28c-3.3-.02-5.73-.86-7.29-2.52l-.04-.04.02-.01c1.21-1.2 1.71-3.39 1.54-6.57l-.01-.09v.01c0-1.87.3-3.41.87-4.66.48-1.05 1.13-1.86 1.92-2.46.63-.48 1.31-.8 2-1l.06-.02c.43-.11.83-.16 1.04-.16z"
}), /*#__PURE__*/React.createElement("circle", {
  id: "burglary-notification_svg__Oval_1_",
  className: "burglary-notification_svg__st0",
  cx: 20.46,
  cy: 21.76,
  r: 3.54
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval_2_",
  d: "M13.11 9.85a1.775 1.775 0 012.53 2.49l-.02.02-.34-.34c.5-.5.5-1.32 0-1.82s-1.32-.5-1.82 0-.5 1.3-.01 1.8l.01.02-.34.34c-.7-.7-.7-1.82-.01-2.51z"
}), /*#__PURE__*/React.createElement("g", {
  id: "burglary-notification_svg__Group",
  transform: "translate(85 344)"
}, /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Path-2",
  d: "M-77.13-318.71c1.28 1.54 3.41 2.32 6.42 2.34h.09v.49c-3.16 0-5.45-.82-6.85-2.47l-.04-.05.38-.31z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Path-2-Copy",
  d: "M-64.28-318.71c-1.28 1.54-3.41 2.32-6.42 2.34h-.09v.49c3.16 0 5.45-.82 6.85-2.47l.04-.05-.38-.31z"
})), /*#__PURE__*/React.createElement("g", {
  id: "burglary-notification_svg__Group-2",
  transform: "translate(30 9)"
}, /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval_3_",
  d: "M-8.85 4.67l-.48-.09c.23-1.17-.53-2.31-1.69-2.55l-.04-.01.09-.48a2.68 2.68 0 012.12 3.09v.04z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval-Copy-18",
  d: "M-7.17 5.24l-.48-.09c.42-2.14-.96-4.21-3.08-4.66l-.06-.01.09-.48c2.4.47 3.97 2.77 3.55 5.16l-.02.08z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval-Copy-20",
  d: "M-22.62 4.67l.48-.09c-.23-1.17.53-2.31 1.69-2.55l.04-.01-.09-.48a2.68 2.68 0 00-2.12 3.09v.04z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval-Copy-19",
  d: "M-24.3 5.24l.48-.09c-.42-2.14.96-4.21 3.08-4.66l.06-.01-.08-.48c-2.4.47-3.97 2.77-3.55 5.16l.01.08z"
})), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Oval_4_",
  d: "M20.46 17.73c-2.23 0-4.03 1.8-4.03 4.03s1.8 4.03 4.03 4.03 4.03-1.8 4.03-4.03-1.81-4.03-4.03-4.03zm0 .48c1.96 0 3.54 1.59 3.54 3.54s-1.59 3.54-3.54 3.54-3.54-1.59-3.54-3.54 1.58-3.54 3.54-3.54z"
}), /*#__PURE__*/React.createElement("g", {
  id: "burglary-notification_svg__Group-3",
  transform: "translate(346 227)"
}, /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Line",
  d: "M-325.32-207.4l.02 3.25h-.48l-.03-3.25z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Line-Copy",
  d: "M-325.3-203.66v.58h-.48v-.58z"
})), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Rectangle",
  fillRule: "evenodd",
  clipRule: "evenodd",
  fill: "#fff",
  d: "M4 19.57h6.41v4.32H4z"
}), /*#__PURE__*/React.createElement("path", {
  id: "burglary-notification_svg__Combined-Shape_1_",
  d: "M10.46 19.38c.03 0 .06 0 .08.01.09-.03.19.01.26.09.05.06.06.14.04.21.01.03.01.05.01.08v4.03c0 .21-.17.39-.39.39H3.9a.39.39 0 01-.39-.39v-4.03c0-.03 0-.06.01-.08a.229.229 0 01.04-.21c.06-.08.16-.11.26-.09.03-.01.05-.01.08-.01h6.56zm-.1.74l-2.99 2.3-.01.01c-.05.06-.12.09-.19.09s-.15-.03-.2-.09L4 20.12v3.58h6.36v-3.58zm-.47-.25H4.47l2.71 2.09 2.71-2.09z"
}))));

function SvgBurglaryNotification(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "burglary-notification_svg__Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    x: 0,
    y: 0,
    viewBox: "0 0 24 24",
    xmlSpace: "preserve"
  }, props), _ref, _ref2);
}

export default __webpack_public_path__ + "dd5086c34642c1c9c8b96bca681d7bf6.svg";
export { SvgBurglaryNotification as ReactComponent };